import React from 'react';
import { useIntl } from 'react-intl';
import { Title } from '../styles';

export const TypesTitle = (): JSX.Element => {
  const intl = useIntl();

  return <Title data-testid="resource-types-title">{intl.formatMessage({ id: 'browseBy' })}</Title>;
};
